import React, { useEffect, useState, Fragment } from "react"
import { GatsbyImage } from "gatsby-plugin-image"
import { useAnimation, motion } from "framer-motion"
import { useInView } from "react-intersection-observer"
import { Link } from "gatsby"
import { PortableText } from "@portabletext/react"
import { getGatsbyImageData } from "gatsby-source-sanity"
import { useStaticQuery, graphql } from "gatsby"
import {
  FiMap,
  FiCalendar,
  FiClock,
  FiMapPin
} from "react-icons/fi"
import { Listbox, Transition } from "@headlessui/react"
import { useQuery, useQueryClient } from "@tanstack/react-query"
import { fetcher } from "../lib/api"
import EventsAPIListboxFilter from "../components/EventsAPIListboxFilter"
import * as dayjs from 'dayjs'
var localizedFormat = require('dayjs/plugin/localizedFormat')

const motionSection = {
  hidden: {
    opacity: 0,
    // y: 20,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 1,
      staggerChildren: 0.15,
      staggerDirection: 1,
      // delay: 0.3,
      ease: [0.16, 1, 0.3, 1],
      // when: "beforeChildren",
    },
  },
}
const motionItems = {
  hidden: {
    opacity: 0,
    y: 20,
    // rotate: 20,
  },
  visible: {
    opacity: 1,
    // right: 0,
    y: 0,
    transition: {
      duration: 1,
      ease: [0.16, 1, 0.3, 1],
    },
  },
}
const motionImage = {
  hidden: {
    scale: 1.1,
    opacity: 0,
    // rotate: 20,
  },
  visible: {
    scale: 1,
    opacity: 1,
    transition: {
      duration: 1,
      // ease: [0.87, 0, 0.13, 1],
    },
  },
}

const underline = {
  hidden: {
    // opacity: 0,
    width: 0,
  },
  visible: {
    opacity: 1,
    // right: 0,
    width: "100%",
    transition: {
      duration: 0.6,
      ease: [0.16, 1, 0.3, 1],
    },
  },
}
const title = {
  hidden: {
    opacity: 0,
    y: 20,
  },
  visible: {
    opacity: 1,
    // right: 0,
    y: 0,
    transition: {
      duration: 2,
      ease: [0.16, 1, 0.3, 1],
    },
  },
}
const desc = {
  hidden: {
    opacity: 0,
    y: 20,
  },
  visible: {
    opacity: 1,
    // right: 0,
    y: 0,
    transition: {
      duration: 2,
      ease: [0.16, 1, 0.3, 1],
    },
  },
}

const eventsAPI = ({ block }) => {
  const { heading, text, api, park_ids, default_park_id} = block
  const controls = useAnimation()
  const [ref, inView] = useInView()

  useEffect(() => {
    if (inView) {
      controls.start("visible")
    }
  }, [controls, inView])

  //park ids
  const park_id_arr = park_ids.split(', ').map(x => Number(x))
  console.log("park_id_arr", park_id_arr)

  //events API rehydrate
  const getEvents = async key => {
    console.log("key", key)
    const parkId = key.queryKey[1].id
    console.log("parkId", parkId)

    if (parkId) {
      const res = await fetcher(api, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          park_id: parkId,
        }),
      })

      // console.log("res", res)
      return res
    }
  }

  //events API
  const [selectedPark, setSelectedPark] = useState(default_park_id)
  const { data, status } = useQuery(["events", { id: selectedPark }], getEvents)

  console.log("data", data)

  if (status === "success" && data) {
    const sortedData = data.events.sort((a,b) => new Date(a.event_date) - new Date(b.event_date))
    console.log("sortedData", sortedData)
  }

  const d1 = new Date('2019-06-01');
  console.log("d1", d1)
  // const d2 = new Date('2018-06-01');
  // const d3 = new Date('2019-06-01');

  // const objects = [
  //   { createdAt: d1, name: 'Test 1' },
  //   { createdAt: d2, name: 'Test 2' },
  //   { createdAt: d3, name: 'Test 3' }
  // ];

  // objects.sort((a, b) => a.createdAt - b.createdAt);

  // // [ 'Test 2', 'Test 1', 'Test 3' ]
  // console.log("objects", objects.map(o => o));

  return (
    <motion.section
      ref={ref}
      animate={controls}
      initial="hidden"
      variants={motionSection}
      className="section multicolumn"
    >
      {heading && (
        <div className="module-image-text-carousel__content flex flex-col justify-center mb-8 items-center text-center container max-w-screen-md">
          <h2 className="w-fit h2 mb-6 relative">
            <motion.div variants={title}>{heading}</motion.div>
            <motion.div
              variants={underline}
              className="section-heading__underline bg-orange-400 h-2 w-full absolute -bottom-4 left-0"
            />
          </h2>
          <motion.p variants={desc}>{text}</motion.p>
        </div>
      )}

      <div className="container">
        
        <div className="w-72 mx-auto mb-12">
          <EventsAPIListboxFilter parkIdArray={park_id_arr} defaultPark={default_park_id} selectedPark={selectedPark} setSelectedPark={setSelectedPark} api={api} />
        </div>

        
        {status === "loading" && <div>Searching for events</div>}
        {status === "error" && <div>Something went wrong</div>}

        <ul className="grid grid-cols-1 lg:grid-cols-3 gap-12">
          {status === "success" &&
            data.events.map((x, index) => {
              const eventDay = dayjs(x.event_date).format("dddd")
              const eventDate = dayjs(x.event_date).format("MMM D, YYYY")
              const startTime = dayjs('1/1/1 ' + x.start_time).format("h:mm a")
              const endTime = dayjs('1/1/1 ' + x.end_time).format("h:mm a")



              return (
                <li key={x.event_name + "-" + index}>
                  <article className="overflow-hidden flex flex-col gap-4 border-t border-orange-300 p-6 bg-white rounded-lg shadow-md shadow-orange-200/20 relative h-full">
                    <span className="absolute top-2 right-2 bg-orange-100 px-4 py-1 text-[12px] rounded-xl">
                      {eventDay}
                    </span>
                    <div className="">
                      <h4 className="text-lg font-semibold mb-1 mt-2">
                        {x.event_name}
                      </h4>
                      <p className="text-sm">{x.description}</p>
                    </div>

                    <ul className="grid gap-1">
                      {/* <li>Event Date: {eventDate.toDateString()}</li> */}
                      
                      <li className="flex items-center gap-x-2 text-sm">
                        <FiCalendar className="w-4 h-4 text-orange-500" />
                        <span>{eventDate}</span>
                      </li>
                      <li className="flex items-center gap-x-2 text-sm">
                        <FiClock className="w-4 h-4 text-orange-500"/>
                        {`${startTime} — ${endTime}`}
                      </li>
                      <li className="flex items-center gap-x-2 text-sm"><FiMapPin className="w-4 h-4 text-orange-500"/>{data.park.name}</li>
                    </ul>
                  </article>
                </li>
              )
            })}
        </ul>
      </div>
    </motion.section>
  )
}

export default eventsAPI
